module.exports = __webpack_public_path__ + "img/logo-ffxiv.12e34f18.png";